export const PageHeader = ({ title, subtitle }) => (
  <div className="relative bg-slate-950 text-white overflow-hidden">
    <div className="blob absolute -top-24 -right-24 w-96 h-96 rounded-full bg-sky-600/20 blur-3xl" />
    <div className="blob absolute -bottom-32 left-1/4 w-80 h-80 rounded-full bg-orange-600/20 blur-3xl" style={{ animationDelay: "-7s" }} />
    <img src="/logo-bpbd.png" alt="" className="absolute right-8 top-1/2 -translate-y-1/2 w-44 h-44 object-contain opacity-15 hidden md:block" />
    <div className="relative max-w-7xl mx-auto px-4 py-16">
      <p className="section-label text-orange-500 mb-3 fade-up">BPBD Kabupaten Kayong Utara</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold fade-up-1">{title}</h1>
      <div className="h-1 w-20 rounded bg-gradient-to-r from-orange-500 to-sky-500 mt-5 fade-up-2" />
      {subtitle && <p className="text-slate-400 mt-4 max-w-2xl text-base md:text-lg fade-up-2">{subtitle}</p>}
    </div>
  </div>
);
